import store from '@/store';
import { Channel } from '@/libraries/channel';

const channel = Channel.getInstance('ally');

const allyListeners =  {
	OPEN_ALLY(response: any, metadata: any): void {
		store.dispatch('openAlly');
		(window as any).FS.restart();
		response('ally opened');
	},
	CLOSE_ALLY(response: any, metadata: any, [ toggle ]: any): void {
		if (toggle) {
			store.dispatch('closeAlly');
		} else {
			store.dispatch('closeAllyWithoutReset');
		}
		(window as any).FS.shutdown();
		response('ally closed');
	},
	CLOSE_ALLY_WITHOUT_REPORT(response: any, metadata: any): void {
		store.dispatch('closeAllyWithoutReport');
		response('ally closed');
	},
	DISPLAY_LAUNCHER_DATA(response: any, metadata: any, [ data ]: any): void {
		store.dispatch('displayLauncherData', data);
		response('ally displaying launcher data');
	},
	CLEAR_LAUNCHER_DATA(response: any): void {
		store.dispatch('clearLauncherData');
		response('ally clearing launcher data');
	},
	SET_DATA_PANEL_SIDE(response: any, metadata: any, [ panel ]: any): void {
		store.dispatch('setDataPanelSide', panel);
		response('done');
	},
	ADD_NOTIFICATION(response: any, metadata: any, [ notificationString ]: any): void {
		store.dispatch('addNotification', notificationString);
		response('notification added');
	},
	UPDATE_OB_STEP(response: any, metadata: any, [script]: any): void {
		store.dispatch('updateOnboardingStep', script);
		response('ally received ob step');
	},
	CANCEL_OB_STATE_ALLY(response: any, metadata: any): void {
		store.dispatch('clearOnboardingState');
		response('ally canceled ob mode');
	}
};

function listenToMessageFromParent() {
	channel.ingestHandlers(allyListeners);
}

export { listenToMessageFromParent };
